module.exports = __webpack_public_path__ + "assets/0ecf7106d5d968519ecb0a060a38b0f6.mp3";